import { render, staticRenderFns } from "./Guest-page.vue?vue&type=template&id=b9b45b1c&"
import script from "./Guest-page.vue?vue&type=script&lang=js&"
export * from "./Guest-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports